import './styles.css';
export function LoadingSkeleton() {
  return <span className="loader"></span>;
}
